// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails

import "@hotwired/turbo-rails"

// BUGFIX: Turbo dispatches turbo:load from PageObserver, which only subscribes to
// *future* readystatechange events and never checks where the page already is. A
// deferred script runs after readyState has already flipped to "interactive", so
// Turbo misses that transition and sits until "complete" - i.e. until every image
// on the page has landed. Re-firing readystatechange gets turbo:load out early.
//
// This has to be anchored to DOMContentLoaded rather than a bare timer. Chrome
// happens to run a setTimeout(0) queued here AFTER DOMContentLoaded, but Firefox
// runs it BEFORE. Every turbo:load listener in the member and admin bundles is
// attached on DOM ready, so firing first means they all miss it and the page
// never initializes at all. The inner setTimeout lets jQuery's ready queue drain
// first, since jQuery 3 resolves it in a microtask.
const kickPageObserver = () => document.dispatchEvent(new Event('readystatechange'));

if (document.readyState === 'complete') {
  setTimeout(kickPageObserver, 0);
} else if (document.readyState === 'interactive') {
  document.addEventListener('DOMContentLoaded', () => setTimeout(kickPageObserver, 0), { once: true });
}

import { BridgeElement } from "@hotwired/hotwire-native-bridge"
window.BridgeElement = BridgeElement

import "controllers"

// https://stackoverflow.com/questions/70921317/how-can-i-disable-hotwire-turbo-the-turbolinks-replacement-for-all-forms-in
// Turbo.session.drive = false
Turbo.config.forms.mode = "optin"